export const ShippingMethods = ({onSetShip, methods}) => {
    
    if (methods === 'undefined') return null;    

    const handleChange = (e) => {
        const value = e.target.value;

        value === 'pickup' ? onSetShip(false) : onSetShip(true);
    }

    const items = Object.entries(methods).map(([method, value], index) => (
        Number(value.status) !== 0 && method !== 'local' &&
        <div className="form-check form-check-inline">
            <input onChange={(e) => handleChange(e)} className="form-check-input " type="radio" name="ship-method" id={method} value={method} defaultChecked={index === 1 ? true : false}/>
            <label className="form-check-label fw-bold" htmlFor={method}>{method === 'shipping' ? 'Доставка' : 'Самовивіз'}</label>
        </div>
    ));

    return (
        <div className="mb-2">
            {items}
        </div>
    );
}